export enum RewardGameType { Competition, ForEach, Interval, SingleGoal }
